<!-- eslint-disable vue/no-dupe-v-else-if -->
<template>
  <div id="app">
    <!-- Progress bar -->
    <vue-progress-bar />

    <!-- Change password view -->
    <div
      v-if="['/change-password', '/reset-password'].includes(this.$route.path)"
      style="width: 100%; max-width: 100vw; height: auto; min-height: 100vh; overflow: hidden; box-sizing: border-box;"
    >
      <router-view />
    </div>

    <!-- Public view -->
    <div
      v-if="!isAdminLayout"
      :class="class_var"
      style="width: 100%; max-width: 100vw; height: auto; min-height: 100vh; overflow: hidden; box-sizing: border-box;"
    >
      <router-view />
    </div>

    <!-- Admin view -->
    <div
      v-else
      class="base-container-default"
      :class="{
        'base-container-cc' : (statusTheme == 'cc') || (statusTheme == 'CC'),
        'base-container-kokoro' : (statusTheme == 'kokoro') || (statusTheme == 'Kokoro')
      }"
    >
      <AsideMenu :menu="sidemenuUpdate ? sidemenuUpdate : sidemenu" />

      <div
        class="base-content-default"
        :class="{'base-content-default-slide' : !isAsideMobileExpanded}"
      >
        <NavBar :module="masterModule" />

        <router-view />

        <FooterBar />
      </div>
    </div>

    <!-- Modal component -->
    <overlay
      v-show="isAsideLgActive"
      z-index="z-30"
      @overlay-click="overlayClick"
    />
  </div>
  <!-- </div> -->
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import axios from "axios";
import { computed, ref, reactive, watchEffect, onMounted, onUnmounted, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import menu from "@/menu.js";
import { useRouter, useRoute } from "vue-router";
import menuUser from "@/menuParentAndStudent.js";
import menuEmployee from "@/menuEmployee.js";
import menuFinanceAdm from "@/menuFinanceAdm.js";
import menuFinance from "@/menuFinance.js";
import menuTeacher from "@/menuTeacher.js";
import menuComboard from "@/menuComboard.js";
import menuBooking from "@/menuBooking.js";
import menuCourseAll from "@/menuCourseAll.js";
import menuModule from "@/menuModule.js";
import menuManagement from "@/menuManagement.js";
import NavBar from "@/components/NavBar";
import AsideMenu from "@/components/AsideMenu";
import FooterBar from "@/components/FooterBar";
import Overlay from "@/components/Overlay";
import "@tailwindcss/forms/dist/forms.min.css";
import CryptoJS from "crypto-js";

export default {
  name: "APP",
  components: {
    Overlay,
    FooterBar,
    AsideMenu,
    NavBar,
  },
  data: function () {
    return {
      isAdminLayout: false,
      sidemenu: [],
      class_var: "",
      userObject: Object,
      masterModule: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to.matched.length && to !== from) {
        this.isAdminLayout = this.checkRoleAdmin();
        this.sidemenu = this.mainmenu();
        this.class_var = this.classParent();
        this.userObject = this.userObj();

        this.masterModule = JSON.parse(localStorage.getItem("moduleList"));
      }
    },
  },
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    userObj() {
      // const store = useStore()
      // let user = undefined
      // if ($store.state)
      // {
      //   user = store.state.auth.user
      // }
      return "";
    },
    checkRoleAdmin() {
      if (localStorage.getItem("loginAs") === "administrator") {
        return true;
      } else {
        return false;
      }
    },
    mainmenu() {
      let menuStorage = localStorage.getItem("isActiveModule");
      const user_id = localStorage.getItem("user_id");
      const checkUser = ref(false);
      const checkUserFinance = ref(false);
      const checkUserTeacher = ref(false);
      const checkUserYayasan = ref(false);
      const checkUserManagement = ref(false);
      if (user_id !== null) {
        const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem("role"),"amatra1609").toString(CryptoJS.enc.Utf8);
        if (decryptedMessage === "ROLE_TEACHER") {
          checkUserTeacher.value = true;
        }
        if (decryptedMessage === "ROLE_ADMIN_FINANCE") {
          checkUser.value = true;
        }
        if (decryptedMessage === "ROLE_FINANCE") {
          checkUserFinance.value = true;
        }
        if (decryptedMessage === "ROLE_FOUNDATION") {
          checkUserYayasan.value = true;
        }
        if (decryptedMessage === "ROLE_MANAGEMENT") {
          checkUserManagement.value = true;
        }

        const myArray = decryptedMessage.split(",");
        for (let i = 0; i < myArray.length; i++) {
          if (myArray[i] === "ROLE_TEACHER") {
            checkUserTeacher.value = true;
          }
          if (myArray[i] === "ROLE_ADMIN_FINANCE") {
            checkUser.value = true;
          }
          if (myArray[i] === "ROLE_FINANCE") {
            checkUserFinance.value = true;
          }
          if (myArray[i] === "ROLE_FOUNDATION") {
            checkUserYayasan.value = true;
          }
          if (myArray[i] === "ROLE_MANAGEMENT") {
            checkUserManagement.value = true;
          }
        }
      }
      // const userCheck = async () => {

      // }

      let listmenu = [];
      if (checkUserManagement.value == true) {
        listmenu = menuManagement;
      } else if (menuStorage == "ACA") {
        if (checkUserTeacher.value) {
          listmenu = menuTeacher;
        } else {
          listmenu = menu;
          //  listmenu = menuCourseAll;
        }
      } else if (menuStorage == "FINA") {
        if (checkUserFinance.value) {
          listmenu = menuFinance;
        }
        if (checkUser.value || checkUserYayasan.value) {
          listmenu = menuFinanceAdm;
        }
      } else if (menuStorage == "HUCAP") {
        listmenu = menuEmployee;
      } else if (menuStorage == "COM") {
        listmenu = menuComboard;
      } else if (menuStorage == "BOOKING") {
        listmenu = menuBooking;
      } else if (menuStorage == "COURSE") {
        listmenu = menuCourseAll;
      } else {
        if (
          ["ADMISS", "AD", "REGIST", "SUBJECT", "CLUB"].includes(menuStorage)
        ) {
          listmenu = menuModule;
        }
      }

      return listmenu;
    },
    classParent() {
      let loginStorage = localStorage.getItem("loginAs");
      let class_var = "";

      if (loginStorage === "parent" || loginStorage === "student") {
        class_var = "parent-container";
      } else if (loginStorage === "booking") {
        class_var = "booking-container";
      }
      return class_var;
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute()
    const { t } = useI18n({ useScope: "global" });
    const store = useStore();
    const isAsideMobileExpanded = computed(
      () => store.state.isAsideMobileExpanded
    );
    const user = ref({});
    const userRole = localStorage.getItem("roles");
    const parentRole = localStorage.getItem("loginAs") === "parent";
    const studentRole = localStorage.getItem("loginAs") === "student";
    const bookingRole = localStorage.getItem("loginAs") === "booking";
    // store.state.auth.user = null
    if (store.state.auth.user) {
      store.commit("user", {
        name: store.state.auth.user.name,
        email: store.state.auth.user.email,
        avatar:
          "",
      });
      user.value = store.state.auth.user;
    }
    const isAsideLgActive = computed(() => store.state.isAsideLgActive);

    const overlayClick = () => {
      store.dispatch("asideLgToggle", false);
    };
    const limitLogin = async () => {
      const url = "check-limit-login";
      const method = "POST";

      const params = {
        user_id: localStorage.getItem("user_id"),
        loginAS: localStorage.getItem("loginAs"),
      };

      await axios({
        method,
        url,
        params,
      })
        .then((response) => {
          if (response.data.olddate < response.data.newdate) {
            // router.push(response.data.status)
            // localStorage.clear()
          }
        })
        .catch((error) => {
          console.log(error);
          let status = "/login";
          if (localStorage.getItem("loginAs") == "student") {
            status = "/login-student";
          } else if (localStorage.getItem("loginAs") == "parent") {
            status = "/login-parent";
          } else if (localStorage.getItem("loginAs") == "booking") {
            status = "/login-booking";
          }

          router.push(status);
          // localStorage.clear()
        });
    };

    const statusTheme = computed(() => process.env.VUE_APP_DEFAULT_THEME)
    const getAllData = async (date) => {
      const headers = {'Content-Encoding': 'gzip'}

      try {
        const [response1] = await Promise.all([
          axios.get("general-setting", { headers })
        ])

        if(response1.data.data) {
          localStorage.setItem('BasicTheme', response1.data.data.value)
          statusTheme.value = response1.data.data.value
        }
      }
      catch(error) {
        console.log(error)
      }
    }


    const userId = computed(() => localStorage.getItem('user_id'))
    const totalChild = reactive({
      total: 0,
      state: false
    })
    const sidemenuUpdate = []

    const getSetData = async () => {
      const thisDate = new Date()
      let thisYear = thisDate.getFullYear()
      let thisMonth = ('0' + (thisDate.getMonth() + 1)).slice(-2)
      const monthNow = (thisYear + '-' + thisMonth)

      const headers = {'Content-Encoding': 'gzip'}

      const testParams1 = {
        user_id: userId.value,
        is_personal: 0,
        year: thisYear,
        month: thisMonth
      }

      try {
        const [response1] = await Promise.all([
          axios.get("get-leave-history", { headers, params: testParams1 })
        ])

        if(response1.data.data) {
          const backData = response1.data.data
          // console.log("cek back app", backData)
          // totalChild.total = backData[0].child_list.length

          totalChild.total = (backData.length < 2) ? backData[0].child_list.length : backData.length
          totalChild.state = (totalChild.total != 0) ? true : false
          localStorage.setItem('child', totalChild)

          if(totalChild.state ) {
            sidemenuUpdate.value = menuEmployee
            // console.log("cek menu employee", menuEmployee)
          }
        }
      }
      catch(error) {
        console.log(error)
      }
    }

    onBeforeMount(() => {

      getAllData()
    })

    watchEffect(() => {
      if(
        (route.path == '/login') ||
        (route.path == '/login-booking') ||
        (route.path == '/login-parent') ||
        (route.path == '/login-student') ||
        (route.path == '/reset-password') ||
        (route.path == '/change-password') ||
        (route.path == '/change-password-booking') ||
        (route.path == '/change-password-parent') ||
        (route.path == '/change-password-student')
      ) {
        getAllData()
      }


      // console.log("cek route", route.path)
      if(route.path == '/hr-dashboard') {
        getSetData()
      }
    })

    onMounted(() => {
      if (document.readyState == "complete") {
        // fetch to next page or some code
      }
      // userCheck()
      // limitLogin()

      // if(localStorage.getItem('loginAs') === 'administrator') {
      //   checkRoleAdmin.value === true
      // } else {
      //   checkRoleAdmin.value === false
      // }
    });

    return {
      router,
      route,
      menu,
      menuUser,
      menuEmployee,
      menuFinanceAdm,
      menuTeacher,
      menuFinance,
      menuComboard,
      menuBooking,
      menuModule,
      menuManagement,
      isAsideLgActive,
      isAsideMobileExpanded,
      overlayClick,
      t,
      parentRole,
      studentRole,
      bookingRole,
      statusTheme
    };
  },
  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish();
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    // this.$router.beforeEach((to, from, next) => {
    //   //  does the page we want to go to have a meta.progress object
    //   if (to.meta.progress !== undefined) {
    //     const meta = to.meta.progress
    //     // parse meta tags
    //     this.$Progress.parseMeta(meta)
    //   }
    //   //  start the progress bar
    //   this.$Progress.start()
    //   //  continue to next page
    //   next()
    // })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish();
    });
  },
  beforeCreate() {
    const store = useStore();
    const router = useRouter();

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        console.log("error axios 401", error);
        if (error && error.response && error.response.status === 401) {
          let loginAs = localStorage.getItem("loginAs");
          if (loginAs === "administrator") {
            store.dispatch("logout").then(() => {
              router.push("/login");
            });
          }
          if (loginAs === "student") {
            store.dispatch("logoutStudent").then(() => {
              router.push("/login-student");
            });
          }
          if (loginAs === "parent") {
            store.dispatch("logoutParent").then(() => {
              router.push("/login-parent");
            });
          }
          if (loginAs === "booking") {
            store.dispatch("logoutBooking").then(() => {
              router.push("/login-booking");
            });
          }
        }
        return Promise.reject(error);
      }
    );
  },
};
</script>
